<template>
  <div style="margin-left: -1px;">
    <el-menu
      background-color="#000"
      class="pg-menu"
      :router="true"
      :default-active="$route.path"
      :collapse="isCollapse"
      @select="handleClick">
        <el-menu-item index="/dashboard/" class="hide-mobile">
          <i class="el-icon-menu"></i>
          <span slot="title">Dashboard</span>
        </el-menu-item>

        <el-menu-item index="/dashboard/stations" class="hide-mobile">
          <i class="el-icon-location"></i>
          <span slot="title">Stations</span>
        </el-menu-item>

        <el-menu-item index="/dashboard/organizations" class="hide-mobile">
          <fa icon="building" class="icon" />
          <span slot="title">Organizations</span>
        </el-menu-item>

        <el-menu-item index="/dashboard/transactions" class="hide-mobile">
          <fa icon="credit-card" class="icon" />
          <span slot="title">Saldo & Credit</span>
        </el-menu-item>

        <el-submenu index="2" v-if="isAdmin">
          <template slot="title">
            <i class="el-icon-star-on" />
            <span slot="title">Administrator</span>
          </template>
          <el-menu-item-group title="Organization administration">
            <el-menu-item
              v-for="userOrg in $root.userOrganizations"
              v-if="userOrg.isOrganizationAdmin"
              :index="'/dashboard/admin/organizations/'+userOrg.organization.id"
              :key="userOrg.id">
                {{ userOrg.organization.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3" v-if="$auth.user.isSystem">
          <template slot="title">
            <fa icon="cog" class="icon" />
            <span slot="title">System</span>
          </template>
          <el-menu-item-group title="System">
            <el-menu-item index="/dashboard/system/stations">Stations</el-menu-item>
            <el-menu-item index="/dashboard/system/organizations">Organizations</el-menu-item>
            <el-menu-item index="/dashboard/system/users">Users</el-menu-item>
            <el-menu-item index="/dashboard/system/countries">Countries</el-menu-item>
            <el-menu-item index="/dashboard/system/currencies">Currencies</el-menu-item>
            <el-menu-item index="/dashboard/system/billing">Billing overview</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    isCollapse: {
      type: Boolean,
      required: true
    },
    toggleNav: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      translationCenter: 0,
      news: 0,
      timer: null
    }
  },
  computed: {
    isAdmin () {
      const isAdmin = this.$root.userOrganizations.find(item => item.isOrganizationAdmin)
      return isAdmin !== undefined && isAdmin !== null
    }
  },
  methods: {
    handleClick (index) {
      if (!this.isCollapse && window.innerWidth <= 768) {
        this.toggleNav()
      }
    }
  },
  created () {
    console.log(this.$root.userOrganizations)
  }
}
</script>

<style lang="scss" scoped>
.profile {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
}

.nav-button {
  position: absolute;
  font-size: 18px;
  right: 25px;
  top: 20px;
  z-index: 99999999;
  cursor: pointer;

  @include breakpoint (xs) {
    display: none;
    color: black;
  }
}

.pg-menu:not(.el-menu--collapse) {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Menu.vue